import React from 'react';
import '../less/InsuranceTour.less';
import FAQStorybook from '@abank/abank-faq';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import hero_img from '../img/hero_img.png';
import Hero from '../../../auxiliary-components/shared/HeroBlock';
import Tariffs from '../../../auxiliary-components/shared/TariffsBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import additionalCards from '../enums/additional_cards_data.json';
import QuestionsFullAdmin from '../../../auxiliary-components/shared/QuestionsFullAdmin';
import insurerInfoDataConfig from '../enums/insurer_info_data.json';
import intermediaryTariffsData from '../enums/intermediary_tariffs_data.json';
import Tabs from '../../../auxiliary-components/shared/Tabs';
import { insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoEiaLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink, insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoTaslifeLink, insuranceIntermediaryInfoInskLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoUniversalnaLink,insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoVusoLink, insuranceDocumentsTasCompanyLink, insuranceDocumentsTasProductLink, insuranceDocumentsUniversalnaCompanyLink, insuranceDocumentsUniversalnaProductLink, insuranceDocumentsVusoCompanyLink, insuranceDocumentsVusoProductLink, insuranceDocumentsArxCompanyLink, insuranceDocumentsArxProductLink, insuranceDocumentsEuroinsCompanyLink, insuranceDocumentsEuroinsProductLink, insuranceDocumentsUniqaCompanyLink, insuranceDocumentsIngoCompanyLink, insuranceDocumentsIngoProductLink, insuranceDocumentsUsgCompanyLink, insuranceDocumentsUsgProductLink, insuranceDocumentsPzuCompanyLink, insuranceDocumentsPzuProductLink, insuranceDocumentsRespectCompanyLink, insuranceDocumentsRespectProductLink, insuranceDocumentsInterExpressCompanyLink, insuranceDocumentsInterExpressProductLink, insuranceDocumentsEuroTravelinsCompanyLink, insuranceDocumentsEuroTravelinsProductLink, insuranceDocumentsTasLifeCompanyLink, insuranceDocumentsTasLifeProductLink, insuranceDocumentsInskCompanyLink, insuranceDocumentsInskProductLink, insuranceDocumentsInterPolicyCompanyLink, insuranceDocumentsInterPolicyProductLink, insuranceDocumentsUniqaProductLink } from '../../../services/urls/urls';
import { Preloader } from 'MWComponents';
import intermediaryInfoDataConfig from '../enums/intermediary_info_data.json';
import InsuranceIntermediaryInfo from '../../../auxiliary-components/shared/InsuranceIntermediaryInfo';
import Advantages from '../../../auxiliary-components/shared/AdvantagesBlock';
import AdditionalProduct from '../../../auxiliary-components/shared/AdditionalProductBlock';
import QuestionsAdminNew from '../../../auxiliary-components/shared/QuestionsAdminNew';
import { mapInsuranceDetailedInfoToTariffs } from './../../../helpers/utils/mapInsuranceDetailedInfoToTariffs';
import { filterByEnvironment } from '../../../helpers/utils/environmentFilter';
import { canUseDOM } from '../../../helpers/canUseDOM';

export default function template() {
  const page = "insurance-tour-new";

  const tabs = [{tab: 'insurer-info', title: 'INSURANCE_TOUR_NEW_TABS_TITLE_01'},
        {tab: 'partners', title: 'INSURANCE_TOUR_NEW_TABS_TITLE_02'},
        {tab: 'insurance-info', title: 'INSURANCE_TOUR_NEW_TABS_TITLE_03'},
        {tab: 'intermediary-info', title: 'INSURANCE_TOUR_NEW_TABS_TITLE_04'}];
  
  const tabsShortInsuranceInfo= [{tab: 'univers-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_01'},
        {tab: 'tas-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_02'},
        {tab: 'vuso-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_03'},
        {tab: 'arx-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_04'},
        {tab: 'evroins-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_05'},
        {tab: 'uniqa-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_06'},
        {tab: 'taslife-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_07'},
        {tab: 'ets-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_08'},
        {tab: 'respect-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_09'},
        {tab: 'pzu-short', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_10'}];

  const tabsFullInsuranceInfo = [{tab: 'univers-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_01'},
        {tab: 'tas-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_02'},
        {tab: 'vuso-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_03'},
        {tab: 'arx-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_04'},
        {tab: 'evroins-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_05'},
        {tab: 'uniqa-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_06'},
        {tab: 'taslife-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_07'},
        {tab: 'ets-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_08'},
        {tab: 'respect-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_09'},
        {tab: 'pzu-full', title: 'INSURANCE_TOUR_NEW_TABS_INSURANCE_INFO_TITLE_10'}];

  const imagesMap = {
    advantages_img_1,
    advantages_img_2,
    advantages_img_3,
    advantages_img_4
  };

  const linksMap = { insuranceIntermediaryInfoArxLink, insuranceIntermediaryInfoVusoLink,  insuranceIntermediaryInfoUniversalnaLink, insuranceIntermediaryInfoUniqaLink, insuranceIntermediaryInfoEiaLink,insuranceIntermediaryInfoEurotravelinsLink, insuranceIntermediaryInfoArsenalLink, insuranceIntermediaryInfoEuroinsLink, insuranceIntermediaryInfoIngoLink, insuranceIntermediaryInfoInterexpressLink, insuranceIntermediaryInfoInterpolicyLink, insuranceIntermediaryInfoOrantaLink, insuranceIntermediaryInfoPzuLink,insuranceIntermediaryInfoRespectinsLink, insuranceIntermediaryInfoSgtasLink, insuranceIntermediaryInfoUkringroupLink, insuranceIntermediaryInfoUticoLink, insuranceIntermediaryInfoArxlifeLink, insuranceIntermediaryInfoKniazhaLink, insuranceIntermediaryInfoTaslifeLink, insuranceIntermediaryInfoInskLink,insuranceDocumentsTasCompanyLink, insuranceDocumentsTasProductLink, insuranceDocumentsUniversalnaCompanyLink, insuranceDocumentsUniversalnaProductLink, insuranceDocumentsVusoCompanyLink, insuranceDocumentsVusoProductLink, insuranceDocumentsArxCompanyLink, insuranceDocumentsArxProductLink, insuranceDocumentsEuroinsCompanyLink, insuranceDocumentsEuroinsProductLink, insuranceDocumentsUniqaCompanyLink, insuranceDocumentsUniqaProductLink, insuranceDocumentsIngoCompanyLink, insuranceDocumentsIngoProductLink, insuranceDocumentsUsgCompanyLink, insuranceDocumentsUsgProductLink, insuranceDocumentsPzuCompanyLink, insuranceDocumentsPzuProductLink,insuranceDocumentsRespectCompanyLink, insuranceDocumentsRespectProductLink, insuranceDocumentsInterExpressCompanyLink, insuranceDocumentsInterExpressProductLink, insuranceDocumentsEuroTravelinsCompanyLink, insuranceDocumentsEuroTravelinsProductLink,insuranceDocumentsTasLifeCompanyLink, insuranceDocumentsTasLifeProductLink, insuranceDocumentsInskCompanyLink, insuranceDocumentsInskProductLink, insuranceDocumentsInterPolicyCompanyLink, insuranceDocumentsInterPolicyProductLink };

  const intermediaryInfoData = intermediaryInfoDataConfig.map(item => {
    if (item.type === 'companies' && item.companies) {
      return {
        ...item,
        companies: item.companies.map(company => ({
          ...company,
          link: linksMap[company.link]
        }))
      };
    }
    return {
      ...item
    };
  });

  const insurerInfoData = insurerInfoDataConfig.map(item => ({
    ...item,
    values: item.values.map(val => {
      if (val.type === 'button') {
        return {
          ...val,
          btnLink: linksMap[val.btnLink],
        };
      }

      return val;
    }),
  }));

  const hero_data = {
    title: "INSURANCE_TOUR_NEW_HERO_TITLE",
    text: "INSURANCE_TOUR_NEW_HERO_TEXT"
  }
  
  const advantagesItems = advantagesItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  const questionsWidget = this.widgetsHelper.getWidget.call(this, 'questions');
  const partnersWidget = this.widgetsHelper.getWidget.call(this, 'partners');
  
  const detailedInsuranceInfoWidgets = [
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoUniversWidget', 'questions'), loadingKey: 'detailedInfoUniversWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoTasWidget', 'questions'), loadingKey: 'detailedInfoTasWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoVusoWidget', 'questions'), loadingKey: 'detailedInfoVusoWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoArxWidget', 'questions'), loadingKey: 'detailedInfoArxWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoEvroinsWidget', 'questions'), loadingKey: 'detailedInfoEvroinsWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoUniqaWidget', 'questions'), loadingKey: 'detailedInfoUniqaWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoTaslifeWidget', 'questions'), loadingKey: 'detailedInfoTaslifeWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoEtsWidget', 'questions'), loadingKey: 'detailedInfoEtsWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoRespectWidget', 'questions'), loadingKey: 'detailedInfoRespectWidget_loading'},
    {widget: this.widgetsHelper.getWidgetFrom.call(this, 'detailedInfoPzuWidget', 'questions'), loadingKey: 'detailedInfoPzuWidget_loading'}
  ];

  return (
    <div className="insurance-tour-new">
      <Hero
        data={hero_data}
        img={hero_img}
      />
      <div className={`content${(this.state.faqTab || this.state.detailedInsuranceInfoTab || this.state.intermediaryInsuranceInfoTab) ? ' hidden' : ''}`}>
          <div className="general-info">
            <div className="container">
              <h2 className="general-info__title">{this.l10n('INSURANCE_TOUR_NEW_GENERAL_INFO_TITLE')}</h2>
              <div className="general-info__body">
                <div className="general-info__text">{this.l10n('INSURANCE_TOUR_NEW_GENERAL_INFO_TEXT')}</div>
                <div className="general-info__subtitle">{this.l10n('INSURANCE_TOUR_NEW_GENERAL_INFO_SUBTITLE')}</div>
                <ul className="general-info__list">
                  <li>{this.l10n('INSURANCE_TOUR_NEW_GENERAL_INFO_LIST_01')}</li>
                  <li>{this.l10n('INSURANCE_TOUR_NEW_GENERAL_INFO_LIST_02')}</li>
                  <li>{this.l10n('INSURANCE_TOUR_NEW_GENERAL_INFO_LIST_03')}</li>
                  <li>{this.l10n('INSURANCE_TOUR_NEW_GENERAL_INFO_LIST_04')}</li>
                  <li>{this.l10n('INSURANCE_TOUR_NEW_GENERAL_INFO_LIST_05')}</li>
                </ul>
              </div>
            </div>
          </div>
          <Advantages
            items={advantagesItems}
            title={'INSURANCE_TOUR_NEW_ADVANTAGES_TITLE'}
          />
          <Tabs tabs={tabs} toggle={this.toggleTab} tab={this.state.tab}>
            <Tariffs
              items={insurerInfoData}
            />
            {this.state.loader ? (canUseDOM ? <Preloader/> : null) : (partnersWidget && partnersWidget.data && partnersWidget.data.length > 0 ? (
              <div className="partners">
                <div className="container">
                  <div className="partners__body">
                    {partnersWidget.data.sort((a, b) => a.order - b.order).map((item, index) => (
                    <div className="partners__item" key={index}>
                      <img className="partners__image" src={item.img_desktop} alt="partners image"/>
                    </div>
                  ))}
                  </div>
                </div>
              </div>
            ) : null)}
            <Tabs tabs={tabsShortInsuranceInfo} toggle={this.toggleShortInsuranceInfoTab} tab={this.state.tabShortInsuranceInfo} title={'INSURANCE_TOUR_NEW_TABS_TITLE'}>
              {detailedInsuranceInfoWidgets.map(({widget, loadingKey}, index) => {
                const detailedInfoTariffsItems = mapInsuranceDetailedInfoToTariffs(widget);

                if (this.state[loadingKey]) {
                  return canUseDOM ? <Preloader key={index}/> : null;
                }

                if (detailedInfoTariffsItems && detailedInfoTariffsItems.length > 0) {
                  return (
                    <Tariffs
                      key={index}
                      items={detailedInfoTariffsItems}
                      alignItems="start"
                      onBtnClick={this.toggleDetailedInsuranceInfoTab}
                      btnText={'INSURANCE_TOUR_NEW_TARIFFS_INSURANCE_INFO_BTN'}
                      insuranceInfo
                    />
                  );
                }

                return null;
              })}
            </Tabs>
            <Tariffs
              items={intermediaryTariffsData}
              title={'INSURANCE_TOUR_NEW_TARIFFS_INTERMEDIARY_INFO_TITLE'}
              alignItems="start"
              onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
              btnText={'INSURANCE_TOUR_NEW_TARIFFS_INTERMEDIARY_INFO_BTN'}
            />
          </Tabs>
          <AdditionalProduct
            items={additionalCards}
            title={'INSURANCE_TOUR_NEW_ADDITIONAL_PRODUCT_TITLE'}
          />
          <QuestionsAdminNew
            widget={questionsWidget}
            toggleFaqTab={this.toggleFaqTab}
            title={'INSURANCE_TOUR_NEW_QUESTIONS_TITLE'}
            loader={this.state.loader}
          />
      </div>
      <div className={`content${!this.state.faqTab ? ' hidden' : ''}`}>
        <FAQStorybook
          widget={questionsWidget}
          title={this.l10n('INSURANCE_TOUR_NEW_FAQ_STORYBOOK_TITLE')}
          btnText={this.l10n('INSURANCE_TOUR_NEW_FAQ_STORYBOOK_BTN_TEXT')}
          onBtnClick={this.toggleFaqTab}
          filterByEnvironment={filterByEnvironment}
        />
      </div>
      <div className={`content${!this.state.detailedInsuranceInfoTab ? ' hidden' : ''}`}>
        <div className="insurance-detailed-info">
          <div className="container">
            <div className="insurance-detailed-info__top">
              <h2 className="insurance-detailed-info__title">{this.l10n('INSURANCE_TOUR_NEW_DETAILED_INFO_TITLE')}</h2>
              <button className="insurance-detailed-info__btn" onClick={this.toggleDetailedInsuranceInfoTab}>{this.l10n('INSURANCE_TOUR_NEW_DETAILED_INFO_BTN')}</button>
            </div>
          </div>
        </div>
        <Tabs tabs={tabsFullInsuranceInfo} toggle={this.toggleFullInsuranceInfoTab} tab={this.state.tabFullInsuranceInfo}>
          {detailedInsuranceInfoWidgets.map(({widget}, index) => (
            <QuestionsFullAdmin
              key={index}
              widget={widget}
            />
          ))}
        </Tabs>
      </div>
      <div className={`content${!this.state.intermediaryInsuranceInfoTab ? ' hidden' : ''}`}>
        <InsuranceIntermediaryInfo
          items={intermediaryInfoData}
          title={'INSURANCE_TOUR_NEW_INTERMEDIARY_INFO_TITLE'}
          onBtnClick={this.toggleIntermediaryInsuranceInfoTab}
          btnText={'INSURANCE_TOUR_NEW_INTERMEDIARY_INFO_BTN'}
        />
      </div>
    </div>
  )
}
